/**
 * Zitadel-Mode-Toggle.
 *
 * Per Spec orbit-specs/zitadel-auth-integration.md: Wenn `IDENTITY_ZITADEL_ENABLED`
 * Core-seitig an ist, sollen Mitarbeiter über Zitadel-OIDC laufen — kein Email-
 * Password-Form, keine MFA-UI in Orbit selbst, keine Core /v1/auth/* Calls.
 *
 * Aktivierung im Frontend per ENV-Flag VITE_ZITADEL_ENABLED=1 (Build-Zeit) ODER
 * window.__ORBIT_CONFIG__.zitadelEnabled (Server.js Runtime-Inject in Prod).
 *
 * Wenn das Flag aus ist: alles läuft wie heute mit Legacy-HS256-Login.
 */
export function isZitadelEnabled() {
  if (typeof window !== 'undefined' && window.__ORBIT_CONFIG__?.zitadelEnabled === true) {
    return true;
  }
  return import.meta.env.VITE_ZITADEL_ENABLED === '1';
}

/**
 * Liest Zitadel-Konfiguration. Fehlende Pflichtfelder = Mode kann nicht
 * verwendet werden — fail loud, damit Operator-Admin merkt was fehlt.
 */
export function getZitadelConfig() {
  const fromRuntime = typeof window !== 'undefined' ? window.__ORBIT_CONFIG__ : null;
  const issuer = fromRuntime?.zitadelIssuer ?? import.meta.env.VITE_ZITADEL_ISSUER;
  const clientId = fromRuntime?.zitadelClientId ?? import.meta.env.VITE_ZITADEL_CLIENT_ID;
  const audience = fromRuntime?.zitadelAudience ?? import.meta.env.VITE_ZITADEL_AUDIENCE;
  const postLogoutRedirectUri =
    fromRuntime?.zitadelPostLogoutRedirectUri
    ?? import.meta.env.VITE_ZITADEL_POST_LOGOUT_REDIRECT_URI
    ?? window.location.origin + '/';
  const redirectUri = window.location.origin + '/login/callback';

  if (!issuer || !clientId || !audience) {
    throw new Error(
      `Zitadel-Mode ist enabled, aber Pflicht-Config fehlt: ${[
        !issuer && 'VITE_ZITADEL_ISSUER',
        !clientId && 'VITE_ZITADEL_CLIENT_ID',
        !audience && 'VITE_ZITADEL_AUDIENCE',
      ].filter(Boolean).join(', ')}`,
    );
  }

  return {
    issuer,
    clientId,
    audience,
    redirectUri,
    postLogoutRedirectUri,
    scope: `openid profile email offline_access urn:zitadel:iam:org:project:roles ${audience}`,
  };
}
